// infinite scroll
class MarqueeComponent extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.marquee-inner');
    this.marqueeList = this.querySelector('.marquee--list');
    this.marqueeListClone = this.marqueeList.cloneNode(true);

    this.marqueeListClone.classList.add('marquee-duplicate');
    this.marqueeListClone.classList.remove('marquee-original');

    this.windowWidth = window.innerWidth;
    this.marqueeListWidth = this.marqueeList.offsetWidth;
  }

  connectedCallback() {
    (this.windowWidth > this.marqueeListWidth) ? this.initializeMarqueeDuplicates() : this.initializeMarquee();
  }

  initializeMarquee() {
    this.container.appendChild(this.marqueeListClone);
    this.container.style.width = `${2 * this.marqueeListWidth}px`;
  }

  initializeMarqueeDuplicates() {
    const marqueeListCloneRemaining = Math.floor(this.windowWidth / this.marqueeListWidth);
    const marqueeListCloneCount = Math.floor(marqueeListCloneRemaining * 2 - 1);

    for (let i = 0; i < marqueeListCloneCount; i++) {
      const clonedContent = this.marqueeList.cloneNode(true);
      clonedContent.classList.add('marquee-duplicate', `marquee-duplicate--${i}`);
      clonedContent.classList.remove('marquee-original');
      this.container.appendChild(clonedContent);
    }

    this.container.style.width = `${2 * this.windowWidth}px`;

    const marqueeLists = this.querySelectorAll('.marquee--list');
    const marqueeListWidth = this.windowWidth / marqueeListCloneRemaining;

    marqueeLists.forEach(element => {
      element.style.width = `${marqueeListWidth}px`;
    });
  }
}

customElements.define('marquee-component', MarqueeComponent);

// swiper component
class SwiperComponents extends HTMLElement {
  constructor() {
    super();
    this.initSwiper = this.getAttribute('data-swiper');
    this.swiperSlides = this.getAttribute('data-slides');
    this.swiperMobileSlides = this.getAttribute('data-mobile-slides');
    this.spaceBetween = this.getAttribute('data-spaceBetween');
    this.autoHeight = this.getAttribute('data-autoHeight');
    this.swiperAutoHeight = this.autoHeight === 'true';

    if(this.initSwiper === 'false') return;
    this.swiperSlide();

    this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`);
  }

  swiperSlide() {
    var swiper = new Swiper(this.querySelector('[id^="Swiper-"]'), {
      autoHeight: this.swiperAutoHeight,
      slidesPerView: this.swiperMobileSlides,
      spaceBetween: this.calculateSpaceBetween(),
      pagination: {
        el: this.querySelector('[id^="SwiperPagination-"]'),
        clickable: true
      },
      navigation: {
        prevEl: this.querySelector('[id^="SwiperPrev-"]'),
        nextEl: this.querySelector('[id^="SwiperNext-"]')
      },
      breakpoints: {
        750: {
          slidesPerView: this.swiperMobileSlides,
          spaceBetween: this.calculateSpaceBetween(),
        },
        990: {
          slidesPerView: this.swiperSlides,
          spaceBetween: this.spaceBetween,
        }
      }
    });
  }

  calculateSpaceBetween() {
    return this.spaceBetween.toString() === '0' ? 0 : Math.floor(this.spaceBetween / 2);
  }
}

customElements.define('swiper-component', SwiperComponents);

// testimonial
class TestimonialSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.testimonialFirst = this.querySelector('[id^="testimonial-1-"]');
    this.testimonialSecond = this.querySelector('[id^="testimonial-2-"]');
    if (!this.testimonialFirst || !this.testimonialSecond) return;
    this.initPages();
  }
  initPages() {
    var testimonialSecond = new Swiper(this.testimonialSecond, {
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true
    });
    var testimonialFirst = new Swiper(this.testimonialFirst, {
      effect: "fade",
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      thumbs: {
        swiper: testimonialSecond
      }
    });
  }
}
customElements.define('testimonial-component', TestimonialSliderComponent);

// customer nav
class CustomerNavComponents extends HTMLElement {
  constructor() {
    super();

    this.profile = this.querySelector('.js-nav-toggle');
    this.profileName = this.querySelector('.customer-profile--heading');
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      this.expanded = this.getAttribute('aria-expanded');

      if(!this.profileName.contains(event.target)) this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    });
  }
}

customElements.define('customer-nav', CustomerNavComponents);

// media alternates
class MediaAlternateComponents extends HTMLElement {
  constructor() {
    super();

    this.alternateButtonWrap = this.querySelector('.js-alternate__buttons');
    this.alternateLabel = this.querySelector('.js-alternate-label');
    this.alternateLabelText = this.querySelector('.js-alternate-label-text');
    this.alternateButtons = this.querySelectorAll('.js-alternate-button');
    this.alternateImages = this.querySelectorAll('.js-alternate-media');
  }

  connectedCallback() {
    window.matchMedia('(max-width: 750px)').addEventListener('change', () => {
      this.mediaAlternateSwiper();
      if(!this.alternateButtons) return;
      this.moveAlternateButtons();
    });
    if(window.innerWidth < 750) {
      this.mediaAlternateSwiper();
      if(!this.alternateButtons) return;
      this.moveAlternateButtons();
    }

    if(!this.alternateButtons) return;
    window.addEventListener('load', () => this.setMediaAlternateWidth());
    this.popupToggle();
    this.mediaAlternate();
  }

  setMediaAlternateWidth() {
    this.style.setProperty('--media-alternates-width', `${this.querySelector('.alternate__buttons-wrap').offsetWidth}px`);
  }

  popupToggle() {
    this.alternateLabel.addEventListener('click', () => {
      this.expanded = this.alternateButtonWrap.getAttribute('aria-expanded');
      this.alternateButtonWrap.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    });
  }

  mediaAlternate() {
    this.alternateButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const alternateTarget = button.getAttribute('aria-label');

        this.alternateButtonWrap.setAttribute('aria-expanded', 'false');
        if(button.classList.contains('active')) return;

        this.alternateLabelText.innerText = alternateTarget;
        this.alternateImages.forEach((altImage) => altImage.dataset.media === alternateTarget ? altImage.classList.remove('hidden') : altImage.classList.add('hidden'));
        this.alternateButtons.forEach((button) => button.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  mediaAlternateSwiper() {
    var swiper = new Swiper(this.querySelector('#swiper-mediaAlternates'), {
      slidesPerView: 1,
      scrollbar: {
        el: this.querySelector('#swiper-mediaAlternatesScrollbar'),
        hide: true
      }
    });
  }

  moveAlternateButtons() {
    window.innerWidth < 750 ? this.append(this.alternateButtonWrap) : this.querySelector('.product__media-item--inner').append(this.alternateButtonWrap);
  }
}

customElements.define('media-alternates', MediaAlternateComponents);

class carouselComponentCustom extends HTMLElement {
  constructor() {
    super();
    this.swiperIns = null;
    this.carousel = null;
    this.next = null;
    this.prev = null;
    this.paginationEl = null;
  }

  connectedCallback() {
    if (!this.hasListener) {
      this.addEventListener('rvp:rendered', () => {
        if (this.swiperIns) {
          this.swiperIns.update();
          this.setSwiperHeight();
        } else {
          this.initSlider();
        }
      });
      this.hasListener = true;
    }

    if (!this.swiperIns && this.querySelector('.swiper-wrapper > *')) {
      this.initSlider();
    }
  }

  initSlider() {
    if (this.swiperIns) return; // avoid double init
    if (typeof Swiper === 'undefined') {
      return;
    }

    this.carousel = this.querySelector('.swiper');
    if (!this.carousel) return;

    this.next = this.querySelector('[id^="swiper-next-"]');
    this.prev = this.querySelector('[id^="swiper-prev-"]');
    this.paginationEl = this.querySelector('.swiper-pagination');

    const getBool = (key, def = false) => {
      const v = this.carousel.getAttribute(key);
      if (v === null) return def;
      return String(v) === 'true';
    };
    const getNum = (key, def = 0) => {
      const v = parseFloat(this.carousel.getAttribute(key));
      return isNaN(v) ? def : v;
    };

    this.loop = getBool('data-loop', true);
    this.arrow = getBool('data-arrow', true);
    this.pagination = getBool('data-pagination', true);
    this.autoplay = getBool('data-autoPlay', true);
    this.interval = getNum('data-interval', 5000);
    this.transition = getNum('data-transition', 300);

    this.desktop_item = getNum('data-desktop-columns', 4);
    this.tab_item = getNum('data-tabs-columns', 3);
    this.mobile_item = getNum('data-mobile-columns', 1.5);

    this.desktop_spacing = getNum('data-desktop-spacing-grid-horizontal', 20);
    this.spacing = getNum('data-mobile-spacing-grid-horizontal', 12);

    // NaN fallbacks
    this.tab_item = isNaN(this.tab_item) ? this.mobile_item : this.tab_item;
    this.desktop_item = isNaN(this.desktop_item) ? this.tab_item : this.desktop_item;
    this.desktop_spacing = isNaN(this.desktop_spacing) ? 0 : this.desktop_spacing;
    this.spacing = isNaN(this.spacing) ? 0 : this.spacing;

    const breakpoints = {
      640:  { 

        slidesPerView: this.mobile_item,  
        spaceBetween: this.spacing 
      },
      768:  { 

        slidesPerView: this.tab_item,     
        spaceBetween: this.desktop_spacing 
      },
      1024: { 
             
        slidesPerView: this.desktop_item, 
        spaceBetween: this.desktop_spacing 
      }
    };

    // Build pagination/navigation config only if elements exist
    const paginationConfig = (this.pagination && this.paginationEl) ? {
      el: this.paginationEl,
      clickable: true
    } : false;

    const navigationConfig = (this.arrow && this.next && this.prev) ? {
      nextEl: this.next,
      prevEl: this.prev
    } : false;

    this.swiperIns = new Swiper(this.carousel, {
      loop: this.loop,
      spaceBetween: this.spacing,
      autoplay: this.autoplay ? {
        delay: this.interval,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      speed: this.transition,
      slidesPerView: this.mobile_item,
      pagination: paginationConfig,
      navigation: navigationConfig,
      breakpoints,
      on: {
        init: () => this.setSwiperHeight(),
        resize: () => this.setSwiperHeight(),
        imagesReady: () => this.setSwiperHeight()
      }
    });
  }

  slideAutoplayStop() { return this.swiperIns?.autoplay?.stop(); }
  slideAutoplayStart() { return this.swiperIns?.autoplay?.start(); }
  carouselSlideTo(i)   { return this.loop ? this.swiperIns?.slideToLoop(i) : this.swiperIns?.slideTo(i); }

  destroySwiper() {
    if (this.swiperIns) {
      this.swiperIns.destroy(true, true);
      this.swiperIns = null;
    }
  }

  setSwiperHeight() {
    const wrapper = this.carousel?.querySelector('.swiper-wrapper');
    if (wrapper) this.style.setProperty('--swiper-height', `${wrapper.offsetHeight}px`);
  }
}

if (!customElements.get('carousel-component')) {
  customElements.define('carousel-component', carouselComponentCustom);
}


class carouselComponentProduct extends HTMLElement {
  constructor() {
    super();
    this.swiperIns = null;
    this.carousel = null;
    this.next = null;
    this.prev = null;
    this.paginationEl = null;
  }

  connectedCallback() {
    if (!this.hasListener) {
      this.addEventListener('rvp:rendered', () => {
        if (this.swiperIns) {
          this.swiperIns.update();
        } else {
          this.initSlider();
        }
        this.setSwiperHeight();
      });
      this.hasListener = true;
    }

    if (!this.swiperIns && this.querySelector('.swiper-wrapper > *')) {
      this.initSlider();
    }
  }

  initSlider() {
    if (this.swiperIns) return;
    if (typeof Swiper === 'undefined') return;

    this.carousel = this.querySelector('.swiper');
    if (!this.carousel) return;

    this.next = this.querySelector('.swiper-button-next');
    this.prev = this.querySelector('.swiper-button-prev');
    this.paginationEl = this.querySelector('.swiper-pagination');

    const getBool = (key, def = false) => {
      const v = this.carousel.getAttribute(key);
      return v === null ? def : String(v) === 'true';
    };

    const getNum = (key, def = 0) => {
      const v = parseFloat(this.carousel.getAttribute(key));
      return isNaN(v) ? def : v;
    };

    this.loop = getBool('data-loop', true);
    this.arrow = getBool('data-arrow', true);
    this.pagination = getBool('data-pagination', true);
    this.autoplay = getBool('data-autoPlay', false);
    this.interval = getNum('data-interval', 5000);
    this.transition = getNum('data-transition', 300);

    const slidesPerViewMobile = getNum('data-mobile-columns', 1.2);

    const breakpoints = {
      640: { slidesPerView: slidesPerViewMobile, spaceBetween: 12 },
      768: { slidesPerView: getNum('data-tabs-columns', 1), spaceBetween: 20 },
      1024: { slidesPerView: getNum('data-desktop-columns', 4), spaceBetween: 20 }
    };

    const navigationConfig = (this.arrow && this.next && this.prev) ? {
      nextEl: this.next,
      prevEl: this.prev
    } : false;

    const paginationConfig = this.pagination && this.paginationEl ? {
      el: this.paginationEl,
      type: 'fraction',
    } : false;

    this.swiperIns = new Swiper(this.carousel, {
      loop: this.loop,
      slidesPerView: slidesPerViewMobile,
      speed: this.transition,
      autoplay: this.autoplay ? { delay: this.interval, disableOnInteraction: false } : false,
      navigation: navigationConfig,
      pagination: paginationConfig,
      breakpoints,
      on: {
        init: () => this.setSwiperHeight(),
        resize: () => this.setSwiperHeight(),
        imagesReady: () => this.setSwiperHeight()
      }
    });
  }

  setSwiperHeight() {
    const wrapper = this.carousel?.querySelector('.swiper-wrapper');
    if (wrapper) this.style.setProperty('--swiper-height', `${wrapper.offsetHeight}px`);
  }
}

if (!customElements.get('carousel-component-product')) {
  customElements.define('carousel-component-product', carouselComponentProduct);
}


document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.card__quick-buy-trigger');
  if (!trigger) return;

  document
    .querySelectorAll('.card__quick-buy.modal-opened')
    .forEach(el => el.classList.remove('modal-opened'));

  trigger
    .closest('.card-product')
    .querySelector('.card__quick-buy')
    .classList.add('modal-opened');
});
